module.exports = __webpack_public_path__ + "img/friends-top-m.9cdc6d0e.jpg";